import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbProgressbarConfig } from '@ng-bootstrap/ng-bootstrap';
import { WorkflowStep1Placeholder } from 'src/app/models/workflow';
import { BuilderRequest } from 'src/app/models/requests';
import { OrganisationApiClient } from 'src/app/services/organisation.apiclient';
import { Subscription } from 'rxjs';
import { User } from 'src/app/models/user';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ModalOpenerService } from 'src/app/modals/modal-opener.service';
import { CloudLocationsService } from 'src/app/services/cloudlocations.service';
import { ToastService } from 'src/app/services/toast.service';
import { LoggingService } from 'src/app/services/logging.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-documentplaceholderlistitem',
  templateUrl: './documentplaceholderlistitem.component.html'
})
export class DocumentPlaceholderListItemComponent {
  private _document!: any
  shakebox: any;
  get document(): any {
    return this._document;
  }

  @Input('document') set document(val: any){
    this._document = val;
    if(val.documentType === "RegularPdf") this.showEditDocument = true;
    if(this.document.filetype.toLocaleLowerCase() == ".xbrl"){
      this.striped = true;
		  this.animated = true;
      this.document.progress = 100
    }
  }
  @Input('RequestIndex') position!: number;
  @Input('ItemsInRequest') itemsInRequest!: number;
  @Input('WorkflowId') workflowId!: string;
  @Input('PlaceHolder') placeholder!: WorkflowStep1Placeholder;
  @Input('PlaceHolders') placeholders: WorkflowStep1Placeholder[] | undefined  = [];
  @Input('Request') request!: BuilderRequest;
  @Input() showDocument: boolean = true;
  @Input('SupportedDocumentTypes') supportedDocumentTypes?: string[];
  @Output('PlaceholderDeleted') placeholderDeleted = new EventEmitter<number>();
  @Output('EnableDocumentChangeOrder') enableDocumentChangeOrder = new EventEmitter();
  @Output('OnFileSelectedWorkflow') onFileSelected = new EventEmitter();
  @Output('getRequest') getRequest: EventEmitter<string> = new EventEmitter<string>();
  @Output() openViewer: EventEmitter<any> = new EventEmitter<any>();
  @Output() editDoc: EventEmitter<any> = new EventEmitter<any>();
  @Output('UploadCloudDocuments') uploadCloudDocuments = new EventEmitter();
  instruction: string = "";
  error: string = "";
  state: number = 0;
  striped: boolean = false;
  animated: boolean = false;
  plugins: [] = [];
  user!: User;
  usersubscription: Subscription;
  cloudlocations: any;
  translations:any = <any>{};
  uploadProgress: number = 0;
  showEditDocument: boolean = false;

  constructor(public config: NgbProgressbarConfig, private organisationApiClient: OrganisationApiClient, private authenticationService: AuthenticationService,
    private modalOpenerService: ModalOpenerService, private cloudLocationsService: CloudLocationsService, private toastService: ToastService,
    private loggingService: LoggingService, private translateService: TranslateService,) {
    this.usersubscription = this.authenticationService.currentUser.subscribe((data:any) => {
      this.user = data;
    });
    this.organisationApiClient.getEnabledPlugins(this.user.organisationGuid).subscribe({
      next: (data:any) => {
        this.plugins = data;
      }
    });
    this.getTranslations();
    translateService.onLangChange.subscribe(() => {
      this.getTranslations();
    });
  }

  getTranslations() {
    this.translateService.get([
      'Toasts.Error',
      'CloudLocations.ImportFilesFailed'
    ]).subscribe(translation => {
      this.translations.error = translation['Toasts.Error'];
      this.translations.toastsImportFilesFailed = translation['CloudLocations.ImportFilesFailed'];
    });
  }

  PlaceholderDeleted(position: number){
    this.placeholderDeleted.emit(position);
  }

  addDocumentsCloudLocation() {
    const modalRef = this.modalOpenerService.Open_CloudDocumentUpload(this.request.id, this.plugins, this.supportedDocumentTypes, false);
    modalRef.componentInstance.setUrl.subscribe((requestId: string) => {
      this.getRequest.emit(requestId);
    });
    modalRef.componentInstance.close.subscribe(async (event:any) => {
      modalRef.close();
      try {
        if (!event || !event.externalFiles || event.externalFiles.length == 0) return;
        event.workflowPlaceholderId = this.placeholder.placeholderId;
        event.workflowId = this.workflowId;
        this.uploadCloudDocuments.emit(event);
      } catch (error: any) {
        this.loggingService.logException(error);
        this.toastService.showDefault(this.translations.error, this.translations.toastsImportFilesFailed);
      }
    });
  }
  
  OnFileSelected(event:any, workflowPlaceholderId: number){
    let dossierIndex: number = 0;
    if(this.request?.documentInfo?.length > 0 && workflowPlaceholderId != (this.placeholders && this.placeholders?.length > 0 ? this.placeholders[0].placeholderId : 1)) {
      dossierIndex = this.request.documentInfo.filter(s => (s.workflowPlaceholderId != null ? s.workflowPlaceholderId : 1) <= workflowPlaceholderId).length > 0 ? Math.max(...this.request.documentInfo.filter(s => (s.workflowPlaceholderId != null ? s.workflowPlaceholderId : 1) <= workflowPlaceholderId).map(a => a.dossierIndex))+1 : this.request.actors.length;
    }
    let file = {event, workflowPlaceholderId, dossierIndex};
    this.onFileSelected.emit(file);
  }

  openPreview() {
    this.openViewer.emit({document: this.document});
  }

  editDocument() {
    this.editDoc.emit({document: this.document});
  }
}
